import { IGameItemForSaleByGala } from '~/store/games/types';
type FilterType = 'goldMember' | 'userNotGoldOrNodeOwner' | 'userNotNodeOwner';
const filterList = (
  filterType: FilterType,
  list: any[],
): IGameItemForSaleByGala[] => {
  switch (filterType) {
    case 'userNotGoldOrNodeOwner': {
      return list.filter(e => {
        return (
          !e.galaGoldOnly && !e.nodeOwnerOnly && !e.galaGoldOrNodeOwnerOnly
        );
      });
    }
    // Maybe add something here to filter from others
    case 'goldMember': {
      return list.filter(e => !e.galaGoldOnly);
    }
    case 'userNotNodeOwner': {
      return list.filter(e => !e.nodeOwnerOnly);
    }
    default: {
      return list;
    }
  }
};

export { filterList };
